export const HYPOTHESIS_TEMPLATE = `## Hypothesis
We believe that [for population: client / OS / vertical / geo / campaign type, **only if intrinsic**],
[change] will result in [outcome], because [mechanism].
If falsified, we will [stop / iterate on a specified variant / move to another hypothesis].

> Include population only when it is core to the claim (e.g. CTV-specific).
> For broader hypotheses, leave population out and scope by population at
> experiment-setup time — one hypothesis can spawn several experiments.

## Motivation
Link to parent Bet / Goal / Problem Area this Idea serves, and to the
triggering Observation if one exists on JPD.
If there is no JPD Observation, describe the observation inline here:
"Based on [data source / event / customer signal], we noticed [pattern,
bottleneck, anomaly]." Link to dashboard / query / ticket.
One sentence on why-now if not obvious from the links.

## Measurement
- Primary metric (from standardized KPI list — usually CPA)
- Guardrail metrics (must not degrade — e.g. AUC drop ≤1%, spend within 10% of target)
- Internal / model metrics (intermediate signals — bid stability, model stability, win rate)

## Additional Context
`;
